import { useEffect } from 'react';

export function useAutoScrollOnFocus() {
    useEffect(() => {
        const handleFocus = (event: FocusEvent) => {
            const target = event.target;
            if (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement) {
                setTimeout(() => {
                    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }, 300);
            }
        };

        document.addEventListener('focusin', handleFocus);
        return () => {
            document.removeEventListener('focusin', handleFocus);
        };
    }, []);
}
